import { FunctionComponent, useEffect, useState } from 'react';
import BMO from './Logos/CA/BMO.svg';
import Scotia from './Logos/CA/Scotia.svg';
import RBC from './Logos/CA/RBC.svg';
import TD from './Logos/CA/TD.svg';
import CIBC from './Logos/CA/CIBC.svg';
import NationalBank from './Logos/CA/NationalBank.svg';
import Simplii from './Logos/CA/Simplii.svg';
import HSBC from './Logos/CA/HSBC.svg';
import CWB from './Logos/CA/CWB.svg';
import Laurentian from './Logos/CA/Laurentian.svg';
import Tangerine from './Logos/CA/Tangerine.svg';
import EQBank from './Logos/CA/EQ.svg';
import ATB from './Logos/CA/ATB.svg';
import Manulife from './Logos/CA/Manulife.svg';
import CoastCapital from './Logos/CA/CoastCapital.svg';
import Vancity from './Logos/CA/Vancity.svg';
import Bancorp from './Logos/US/Bancorp.svg';
import BoA from './Logos/US/BoA.svg';
import CapitalOne from './Logos/US/CapitalOne.svg';
import Chase from './Logos/US/Chase.svg';
import Citi from './Logos/US/Citi.svg';
import Goldman from './Logos/US/Goldman.svg';
import PNC from './Logos/US/PNC.svg';
import TDUS from './Logos/US/TD.svg';
import Truist from './Logos/US/Truist.svg';
import Wells from './Logos/US/Wells.svg';
import Icon from '../Icon/Icon';

export type BankLogoProps = {
  width: string;
  height: string;
  financialInstitutionNumber: string;
};

const BankLogo: FunctionComponent<BankLogoProps> = ({ width, height, financialInstitutionNumber }) => {
  const [hasLogo, setHasLogo] = useState(true);
  const bankID = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '12',
    '49',
    '84',
    '98',
    '101',
    '118',
    '119',
    '1887',
    '1888',
    '1889',
    '1890',
    '1893',
    '1896',
    '2493',
    '1891',
    '1897',
    '1895',
  ];
  const [financialInstitutionNumberFormatted, setFinancialInstitutionNumberFormatted] =
    useState(financialInstitutionNumber);

  useEffect(() => {
    setFinancialInstitutionNumberFormatted(financialInstitutionNumber.replace(/^0+/, ''));
  }, [financialInstitutionNumber]);

  useEffect(() => {
    setHasLogo(bankID.includes(financialInstitutionNumberFormatted));
  }, [financialInstitutionNumberFormatted]);

  return (
    <>
      {hasLogo ? (
        <img
          style={{ width, height, borderRadius: '50px' }}
          src={
            financialInstitutionNumberFormatted === '1'
              ? BMO
              : financialInstitutionNumberFormatted === '2'
                ? Scotia
                : financialInstitutionNumberFormatted === '3'
                  ? RBC
                  : financialInstitutionNumberFormatted === '4'
                    ? TD
                    : financialInstitutionNumberFormatted === '5'
                      ? NationalBank
                      : financialInstitutionNumberFormatted === '6'
                        ? CIBC
                        : financialInstitutionNumberFormatted === '7'
                          ? HSBC
                          : financialInstitutionNumberFormatted === '8'
                            ? CWB
                            : financialInstitutionNumberFormatted === '9'
                              ? Laurentian
                              : financialInstitutionNumberFormatted === '12'
                                ? ATB
                                : financialInstitutionNumberFormatted === '49'
                                  ? Simplii
                                  : financialInstitutionNumberFormatted === '84'
                                    ? Manulife
                                    : financialInstitutionNumberFormatted === '98'
                                      ? Tangerine
                                      : financialInstitutionNumberFormatted === '101'
                                        ? EQBank
                                        : financialInstitutionNumberFormatted === '118'
                                          ? CoastCapital
                                          : financialInstitutionNumberFormatted === '119'
                                            ? Vancity
                                            : financialInstitutionNumberFormatted === '1887'
                                              ? Chase
                                              : financialInstitutionNumberFormatted === '1888'
                                                ? BoA
                                                : financialInstitutionNumberFormatted === '1889'
                                                  ? Citi
                                                  : financialInstitutionNumberFormatted === '1890'
                                                    ? Wells
                                                    : financialInstitutionNumberFormatted === '1893'
                                                      ? Bancorp
                                                      : financialInstitutionNumberFormatted === '1896'
                                                        ? PNC
                                                        : financialInstitutionNumberFormatted === '2493'
                                                          ? Truist
                                                          : financialInstitutionNumberFormatted === '1891'
                                                            ? Goldman
                                                            : financialInstitutionNumberFormatted === '1897'
                                                              ? CapitalOne
                                                              : financialInstitutionNumberFormatted === '1895'
                                                                ? TDUS
                                                                : ''
          }
          alt={
            financialInstitutionNumberFormatted === '1'
              ? 'BMO'
              : financialInstitutionNumberFormatted === '2'
                ? 'Scotia'
                : financialInstitutionNumberFormatted === '3'
                  ? 'RBC'
                  : financialInstitutionNumberFormatted === '4'
                    ? 'TD'
                    : financialInstitutionNumberFormatted === '5'
                      ? 'National Bank'
                      : financialInstitutionNumberFormatted === '6'
                        ? 'CIBC'
                        : financialInstitutionNumberFormatted === '7'
                          ? 'HSBC'
                          : financialInstitutionNumberFormatted === '8'
                            ? 'CWB'
                            : financialInstitutionNumberFormatted === '9'
                              ? 'Laurentian'
                              : financialInstitutionNumberFormatted === '12'
                                ? 'ATB'
                                : financialInstitutionNumberFormatted === '49'
                                  ? 'Simplii'
                                  : financialInstitutionNumberFormatted === '84'
                                    ? 'Manulife'
                                    : financialInstitutionNumberFormatted === '98'
                                      ? 'Tangerine'
                                      : financialInstitutionNumberFormatted === '101'
                                        ? 'EQ Bank'
                                        : financialInstitutionNumberFormatted === '118'
                                          ? 'Coast Capital'
                                          : financialInstitutionNumberFormatted === '119'
                                            ? 'Vancity'
                                            : financialInstitutionNumberFormatted === '1887'
                                              ? 'Chase'
                                              : financialInstitutionNumberFormatted === '1888'
                                                ? 'BoA'
                                                : financialInstitutionNumberFormatted === '1889'
                                                  ? 'Citi'
                                                  : financialInstitutionNumberFormatted === '1890'
                                                    ? 'Wells'
                                                    : financialInstitutionNumberFormatted === '1893'
                                                      ? 'Bancorp'
                                                      : financialInstitutionNumberFormatted === '1896'
                                                        ? 'PNC'
                                                        : financialInstitutionNumberFormatted === '2493'
                                                          ? 'Truist'
                                                          : financialInstitutionNumberFormatted === '1891'
                                                            ? 'Goldman'
                                                            : financialInstitutionNumberFormatted === '1897'
                                                              ? 'CapitalOne'
                                                              : financialInstitutionNumberFormatted === '1895'
                                                                ? 'TDUS'
                                                                : ''
          }
        />
      ) : (
        <Icon icon="bank3" width={width} height={height} color="none" />
      )}
    </>
  );
};

export default BankLogo;
